export default {
  namespaced: true,
  state: {
    USERINFO: {
      isTourist: true
    },
    token: '',
    userId: '',
    wxBaseState: false
  },
  mutations: {
    SET_USERINFO (state, value) {
      console.log('value', value)
      state.USERINFO = value
    },
    SET_USER (state, userId) {
      state.userId = userId
    },
    SET_TOKEN (state, token) {
      state.token = token
    },
    SET_WXBASESTATE (state, value) {
      console.log('wxBaseState', value)
      state.wxBaseState = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js